import { Packet } from "../Interfaces/commonDtos";
import {
  IPortfolioAggregateSearchParams,
  IPortfolioAggregateTableReport,
  IPortfolioInsTableReport,
  IPortfolioInsTableSearchParams,
  IPortfolioSearchParams,
  IPortfolioTableReport,
  IDailyPortfoGraphDTO,
  IHourlyPortfoValueGraphDTO,
} from "../Interfaces/portfolio";
import { User } from "../Interfaces/connections";
import { Report } from "../Interfaces/TableInterfaces";
import {
  downloadExcel,
  getTable,
  postRequest,
  getRequest,
} from "./requestTemplates";
import { Graph_Dto } from "src/Interfaces/orderbookGraphInterfaces";

export interface FileResponse {
  blob: Blob;
  filename: string;
}

export const getPortfoExcelFile = () => {
  const rand = Math.random();
  return downloadExcel(`/v1/Portfo/getExcelFile?${rand}`);
};

export const getPortfolioAggregaateTable = (
  searchParam: IPortfolioAggregateSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IPortfolioAggregateTableReport>> =>
  getTable<IPortfolioAggregateSearchParams, IPortfolioAggregateTableReport>(
    "/v1/portfo/getAggregateTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getPortfolioTable = (
  searchParam: IPortfolioSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IPortfolioTableReport>> =>
  getTable<IPortfolioSearchParams, IPortfolioTableReport>(
    "/v1/portfo/getTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );

export const getPortfolioInsTable = (
  searchParam: IPortfolioInsTableSearchParams,
  offset: number | null,
  pageSize: number | null,
  sortingType?: string,
): Promise<Report<IPortfolioInsTableReport>> =>
  getTable<IPortfolioSearchParams, IPortfolioInsTableReport>(
    "/v1/portfo/instrumentTable",
    searchParam,
    offset,
    pageSize,
    sortingType,
  );
export const portfoForceUpdate = (): Promise<Packet<boolean>> =>
  postRequest("/v1/Portfo/forceUpdate", {});

export const getDailyPortfoGraph = (
  dto: IDailyPortfoGraphDTO,
): Promise<Graph_Dto[]> => postRequest("/v1/Portfo/DailyPortfoValueGraph", dto);

export const getHourlyPortfoValueGraph = (
  dto: IHourlyPortfoValueGraphDTO,
): Promise<Graph_Dto[]> =>
  postRequest("/v1/Portfo/HourlyPortfoValueGraph", dto);

export const getUsers = (): Promise<Array<User>> =>
  getRequest("/v1/connection/getUsers?exchangeType=2");
